module.exports = __webpack_public_path__ + "img/add-participant.18af9218.svg";